import TextField from '@material-ui/core/TextField'
import { makeStyles } from '@material-ui/core/styles'
import SearchIcon from '@material-ui/icons/Search'

import NewChatButton from './new-chat-button'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  searchHost: {
    position: 'relative',
    flex: 1,
  },
  searchIcon: {
    position: 'absolute',
    left: theme.spacing(1.5),
    top: '50%',
    transform: 'translateY(-50%)',
    color: 'var(--ds-fg-tertiary, #8c92a5)',
    pointerEvents: 'none',
    zIndex: 1,
  },
  inputRoot: {
    height: 40,
    borderRadius: 12,
    backgroundColor: 'var(--ds-bg-subtle, #f1f2f7)',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--ds-border-default, #d7dae4)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--ds-border-default, #d7dae4)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--ds-border-focus, #f47d6b)',
    },
    '&.Mui-focused': {
      boxShadow: '0 0 0 2px rgba(244, 125, 107, 0.35)',
    },
  },
  inputField: {
    padding: theme.spacing(0, 2, 0, 5),
    fontSize: '0.875rem',
    color: 'var(--ds-fg-primary, #1f2430)',
    '&::placeholder': {
      color: 'var(--ds-fg-tertiary, #8c92a5)',
      opacity: 1,
    },
  },
}))

type SidebarToolbarProps = {
  searchQuery: string
  onSearchChange: (value: string) => void
  onNewChat: () => void
}

const SidebarToolbar = ({ searchQuery, onSearchChange, onNewChat }: SidebarToolbarProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.searchHost}>
        <SearchIcon fontSize="small" className={classes.searchIcon} />
        <TextField
          fullWidth
          value={searchQuery}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Search conversations"
          variant="outlined"
          size="small"
          InputProps={{
            classes: {
              root: classes.inputRoot,
              input: classes.inputField,
            },
          }}
        />
      </div>
      <NewChatButton onClick={onNewChat} />
    </div>
  )
}

export default SidebarToolbar
